/**
 * Sélecteur de cycle pour les statistiques (2026-10-02).
 *
 * Les statistiques ne mélangent jamais licence et master : les M1/M2 ont leur
 * propre vue, la licence (L1-L3) est affichée par défaut.
 */
import React from 'react';

export type Cycle = 'licence' | 'master';

export const NIVEAUX_PAR_CYCLE: Record<Cycle, string[]> = {
  licence: ['L1', 'L2', 'L3'],
  master: ['M1', 'M2'],
};

export const SelecteurCycle: React.FC<{
  value: Cycle;
  onChange: (c: Cycle) => void;
  taille?: 'sm' | 'md';
}> = ({ value, onChange, taille = 'md' }) => {
  const pad = taille === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3.5 py-1.5 text-sm';
  return (
    <div className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden" role="group" aria-label="Cycle">
      {([
        { c: 'licence' as const, label: 'Licence' },
        { c: 'master' as const, label: 'Master' },
      ]).map(({ c, label }) => (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          aria-pressed={value === c}
          className={`${pad} font-medium transition-colors ${
            value === c
              ? 'bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900'
              : 'bg-white text-gray-600 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default SelecteurCycle;
